import {type ComponentProps, forwardRef} from 'react'

import {Link, NavLink} from '../../router'

/**
 * SubNav.Link passes a prop through to the `as` prop, which is not supported
 * so we remove it
 */
export const LinkWithoutActiveClassName = forwardRef<
  HTMLAnchorElement,
  ComponentProps<typeof Link> & {activeClassName?: string}
>(function LinkWithoutActiveClassNamePassThrough({activeClassName, ...p}, forwardedRef) {
  return <Link {...p} ref={forwardedRef} />
})

export const NavLinkWithoutActiveClassName = forwardRef<
  HTMLAnchorElement,
  ComponentProps<typeof NavLink> & {activeClassName?: string}
>(function NavLinkWithoutActiveClassName({activeClassName, ...props}, forwardedRef) {
  return <NavLink {...props} ref={forwardedRef} />
})

try{ LinkWithoutActiveClassNamePassThrough.displayName ||= 'LinkWithoutActiveClassNamePassThrough' } catch {}
try{ NavLinkWithoutActiveClassName.displayName ||= 'NavLinkWithoutActiveClassName' } catch {}